"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsafeDispatchActionEventHandlerActivator = exports.UnsafeDispatchActionEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
/**
 * This handler is "unsafe" because it will dispatch actions at dead targets
 */
class UnsafeDispatchActionEventHandlerArgs {
    constructor(action, dispatchFrom = Target_1.Target.Self) {
        this.action = action;
        this.dispatchFrom = dispatchFrom;
        this.__type = EventHandlerType_1.EventHandlerType.UnsafeDispatchAction;
        this.__typeName = "UnsafeDispatchAction";
    }
}
exports.UnsafeDispatchActionEventHandlerArgs = UnsafeDispatchActionEventHandlerArgs;
let UnsafeDispatchActionEventHandlerActivator = class UnsafeDispatchActionEventHandlerActivator {
    activate(sequence, container, handler, event) {
        container.selectTargets(handler.subject, handler.args.dispatchFrom)
            .forEach(target => container.dispatch(sequence, target, handler.args.action));
    }
};
UnsafeDispatchActionEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.UnsafeDispatchAction)
], UnsafeDispatchActionEventHandlerActivator);
exports.UnsafeDispatchActionEventHandlerActivator = UnsafeDispatchActionEventHandlerActivator;
